import { transform } from "lodash";

(function ($) {
    $(document).ready(function () {
        //Banner
        const optionsBanners = JSON.parse($("#optionsBanners").text());
        let currentStep = parseInt($("#currentStepValue").val());
        $(document).ready(function () {
            $(".hero-11__steps").removeClass("active");
        });
        updateStepDisplay(currentStep);

        $(".hero-11__steps").click(function () {
            const stepIndex = $(this).index();
            const newBackground = optionsBanners[stepIndex + 1];
            $("#hero-section").css("background-image", `url('${newBackground}')`);

            currentStep = stepIndex + 1;
            updateStepDisplay(currentStep);
        });

        function updateStepDisplay(step) {
            $(".hero-11__steps").removeClass("active");
            $(".hero-11__steps:eq(" + (step - 1) + ")").addClass("active");

            if (step === 0) {
                $(".hero-11__texts--slide-1").show();
            } else {
                $(".hero-11__texts--slide-1").hide();
            }
            if (step === 1) {
                $(".hero-11__texts--slide-2").show();
            } else {
                $(".hero-11__texts--slide-2").hide();
            }
            if (step === 2) {
                $(".hero-11__texts--slide-3").show();
            } else {
                $(".hero-11__texts--slide-3").hide();
            }
            if (step === 3) {
                $(".hero-11__texts--slide-4").show();
            } else {
                $(".hero-11__texts--slide-4").hide();
            }
            if (step === 4) {
                $(".hero-11__texts--slide-5").show();
            } else {
                $(".hero-11__texts--slide-5").hide();
            }
        }

        //counter date
        function updateCountdown(targetDate) {
            const now = new Date().getTime();
            const distance = targetDate - now;

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            document.getElementById("days").textContent = days;
            document.getElementById("hours").textContent = hours;
            document.getElementById("minutes").textContent = minutes;
            document.getElementById("seconds").textContent = seconds;
        }

        const targetDate = new Date("2023-11-22T18:59:59").getTime(); // Cambié la fecha a 22 de septiembre

        const countdownInterval = setInterval(function () {
            updateCountdown(targetDate);
        }, 1000);


        // Day of event
        const buttonDay = $('.days__button');
        const contentDay = $('.day');

        buttonDay.eq(0).addClass('active active-left');
        buttonDay.each(function (index) {
            $(this).on('click', function () {
                // Remover todas las clases 'active', 'active-left' y 'active-right' de todos los botones
                buttonDay.removeClass('active active-left active-right');

                // Agregar la clase 'active' al botón clickeado
                buttonDay.eq(index).addClass('active');
                contentDay.removeClass('active');
                contentDay.eq(index).addClass('active');
                // Verificar si estamos avanzando o retrocediendo
                if (index > currentIndex) {
                    buttonDay.eq(index).addClass('active-left');
                } else if (index < currentIndex) {
                    buttonDay.eq(index).addClass('active-right');
                }

                // Actualizar el índice actual
                currentIndex = index;
            });
        });

        let currentIndex = 0; // Variable para rastrear el índice actual

        //swipers
        if ($('.swiper-exposers')) {
            const swiperExposers = new Swiper('.swiper-exposers', {
                spaceBetween: 20,
                loop: false,
                autoplay: {
                    delay: 2000,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                    },
                    640: {
                        slidesPerView: 2,
                    },
                    1140: {
                        slidesPerView: 3,
                    }
                }
            })
        }
        if ($('.swiper-six')) {
            const swiperExposers = new Swiper('.swiper-six', {
                spaceBetween: 20,
                loop: false,
                autoplay: {
                    delay: 2000,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            })
        }
        if ($('.swiper-testimonials')) {
            const swiperTestimonials = new Swiper('.swiper-testimonials', {
                spaceBetween: 20,
                loop: true,
                autoplay: {
                    delay: 2000,
                },
                pagination: {
                    clickable: true,
                    el: '.swiper-pagination',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                    },
                    640: {
                        slidesPerView: 2,
                    },
                    1140: {
                        slidesPerView: 3,
                    }
                }
            })
        }
        if ($('.swiper-experience')) {
            const swiperExperience = new Swiper('.swiper-experience', {
                spaceBetween: 20,
                loop: false,
                autoplay: {
                    delay: 2000,
                },
                pagination: {
                    clickable: true,
                    el: '.swiper-pagination',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                    },
                    640: {
                        slidesPerView: 2,
                    },
                    1140: {
                        slidesPerView: 3,
                    }
                }
            })
        }
        if ($('.swiper-trips')) {
            const swiperTrips = new Swiper('.swiper-trips', {
                spaceBetween: 20,
                loop: false,
                autoplay: {
                    delay: 2000,
                },
                pagination: {
                    clickable: true,
                    el: '.swiper-pagination',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                    },
                    640: {
                        slidesPerView: 2,
                    },
                    1140: {
                        slidesPerView: 3,
                    }
                }
            })
        }
        if ($('.swiper-countries')) {
            const swiperCountries = new Swiper('.swiper-countries', {
                spaceBetween: 20,
                loop: true,
                autoplay: {
                    delay: 2000,
                },
                pagination: {
                    clickable: true,
                    el: '.swiper-pagination',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                    },
                    640: {
                        slidesPerView: 2,
                    },
                    940: {
                        slidesPerView: 3,
                    }
                }
            })
        }
        //Experiences
        let viewMoreBtn = $('.journey__view-more');
        let closeBtn = $('.journey__button--close');
        let contentJourney = $('.journey__description');

        // Cuando se hace clic en el botón "viewMore"
        viewMoreBtn.click(function () {
            // Encuentra el índice del botón que se hizo clic
            var index = viewMoreBtn.index(this);

            // Agrega la clase "active" al elemento correspondiente en "contentJourney"
            contentJourney.eq(index).addClass('active');
        });

        // Cuando se hace clic en el botón "close"
        closeBtn.click(function () {
            // Encuentra el índice del botón que se hizo clic
            var index = closeBtn.index(this);

            // Quita la clase "active" del elemento correspondiente en "contentJourney"
            contentJourney.eq(index).removeClass('active');
        });
        //Questions
        const questions = $('.accordion__h4');
        const responses = $('.accordion__p--inter');

        questions.click(function () {
            const clickedQuestion = $(this);
            const clickedResponse = clickedQuestion.next('.accordion__p--inter');

            questions.removeClass('active').addClass('close');
            responses.removeClass('active').addClass('close');

            if (!clickedResponse.hasClass('active')) {
                clickedResponse.removeClass('close').addClass('active');
                clickedQuestion.removeClass('close').addClass('active');
            }
        });

    });
})(jQuery);
